import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';
import { take } from 'rxjs/operators';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';

@Component({
  selector: 'direct-cap-lease-comps-map-widget',
  templateUrl: './direct-cap-lease-comps-map-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './direct-cap-lease-comps-map-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DirectCapLeaseCompsMapWidgetComponent extends WidgetBaseComponent implements OnInit {
  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("directCapLeaseCompsMap", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.mockupData$ = this.widgetService.loadMockup('directCapLeaseCompsMap').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('directCapLeaseCompsMap', this.getReport()).pipe();
  }

  /**
   * Constructor
   * @param injector
   * @param httpClient
   * @param appServiceHelper
   */
  constructor(injector: Injector) {
    super(injector, 'directCapLeaseCompsMap', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    return data;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }
}
